module.exports = __webpack_public_path__ + "static/media/LVGMC-logo.693d4d49.svg";